/* Inline Header Search - search-as-you-type with dropdown results */

(function () {
  const searchContainer = document.querySelector('.inline-header-search');
  if (!searchContainer) return;

  const searchInput = searchContainer.querySelector('.inline-header-search__input');
  const resultsBox = searchContainer.querySelector('.inline-header-search__results');
  const quickSearch = searchContainer.dataset.quickSearch === 'true';
  const includeMeta = searchContainer.dataset.quickSearchMeta === 'true';
  const resultLimit = 6;
  const searchTimeoutThrottle = 400;

  let searchTimeoutID = -1;
  let searchAbortController = null;
  let oldSearchValue = '';
  let activeResultIndex = -1;

  // Create backdrop element for closing on outside click
  const backdrop = document.createElement('div');
  backdrop.className = 'inline-header-search__backdrop';
  searchContainer.appendChild(backdrop);

  backdrop.addEventListener('click', function () {
    closeResults();
  });

  function closeResults() {
    searchContainer.classList.remove(
      'inline-header-search--has-results',
      'inline-header-search--no-results',
      'inline-header-search--loading'
    );
    resultsBox.innerHTML = '';
    searchInput.setAttribute('aria-expanded', 'false');
    activeResultIndex = -1;
  }

  function buildResultURL(valueToSearch) {
    const form = searchInput.closest('form');
    const linkURL = new URL(form.action, window.location.origin);
    linkURL.searchParams.set('q', valueToSearch);
    return linkURL.toString();
  }

  function handleInputChange() {
    const valueToSearch = searchInput.value.trim();

    if (valueToSearch.length > 0 && valueToSearch !== oldSearchValue) {
      oldSearchValue = valueToSearch;

      // Abort previous request
      if (searchAbortController !== null) {
        searchAbortController.abort();
        searchAbortController = null;
      }
      clearTimeout(searchTimeoutID);

      // Show loading
      searchContainer.classList.remove(
        'inline-header-search--has-results',
        'inline-header-search--no-results'
      );
      searchContainer.classList.add('inline-header-search--loading');
      resultsBox.innerHTML = '<div class="inline-search-spinner"><div class="loading-spinner"></div></div>';

      searchTimeoutID = setTimeout(function () {
        searchAbortController = new AbortController();
        var ajaxUrl;

        if (quickSearch && theme.Shopify.features.predictiveSearch) {
          ajaxUrl = new URL(theme.routes.base + theme.routes.predictiveSearch, window.location.origin);
          ajaxUrl.searchParams.set('q', valueToSearch);
          ajaxUrl.searchParams.set('section_id', 'predictive-search');
          ajaxUrl.searchParams.set('resources[limit]', resultLimit);
          ajaxUrl.searchParams.set(
            'resources[options][fields]',
            includeMeta
              ? 'title,product_type,variants.title,vendor,tag,variants.sku'
              : 'title,product_type,variants.title,vendor'
          );
        } else {
          ajaxUrl = new URL(buildResultURL(valueToSearch));
          ajaxUrl.searchParams.set('section_id', 'main-search');
        }

        fetch(ajaxUrl.toString(), { method: 'get', signal: searchAbortController.signal })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP error: ' + response.status);
            return response.text();
          })
          .then(function (responseText) {
            var template = document.createElement('template');
            template.innerHTML = responseText;

            var resultsList = null;
            var resultsMessage = null;

            if (quickSearch && theme.Shopify.features.predictiveSearch) {
              resultsList = template.content.querySelector('.product-grid');
              resultsMessage = template.content.querySelector('[data-results-message]');
            } else {
              resultsList = template.content.querySelector('.section-search-template .product-grid');
              resultsMessage = template.content.querySelector('.section-search-template [data-results-message]');
            }

            searchAbortController = null;
            searchContainer.classList.remove(
              'inline-header-search--has-results',
              'inline-header-search--no-results',
              'inline-header-search--loading'
            );
            resultsBox.innerHTML = '';

            if (!resultsList) {
              searchContainer.classList.add('inline-header-search--no-results');
              resultsBox.innerHTML = '<div class="inline-search-empty">' + (theme.strings.generalSearchNoResultsWithoutTerms || 'No results found') + '</div>';
              searchInput.setAttribute('aria-expanded', 'false');
              return;
            }

            var productBlocks = resultsList.querySelectorAll('.product-block:not(.collection-block):not(.page-block)');
            var pageBlocks = resultsList.querySelectorAll('.product-block.page-block');

            var hasProducts = productBlocks.length > 0;
            var hasPages = pageBlocks.length > 0;

            if (!hasProducts && !hasPages) {
              searchContainer.classList.add('inline-header-search--no-results');
              resultsBox.innerHTML = '<div class="inline-search-empty">' + (theme.strings.generalSearchNoResultsWithoutTerms || 'No results found') + '</div>';
              searchInput.setAttribute('aria-expanded', 'false');
              return;
            }

            // Build compact product results
            if (hasProducts) {
              var productsDiv = document.createElement('div');
              productsDiv.className = 'inline-search-products';

              productBlocks.forEach(function (block, index) {
                if (index >= resultLimit) return;

                var linkEl = block.querySelector('a[href]');
                var imgEl = block.querySelector('img');
                var titleEl = block.querySelector('.product-block__title-link') || block.querySelector('.product-block__title') || block.querySelector('a');
                var priceEl = block.querySelector('.product-price') || block.querySelector('.price');

                var href = linkEl ? linkEl.getAttribute('href') : '#';
                var title = titleEl ? titleEl.textContent.trim() : '';
                var imgSrc = '';

                if (imgEl) {
                  // Try to get a small version of the image
                  imgSrc = imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || imgEl.getAttribute('data-srcset') || '';
                  // Resize to small thumbnail
                  if (imgSrc && imgSrc.indexOf('cdn.shopify.com') !== -1) {
                    imgSrc = imgSrc.replace(/(_\d+x\d+|_\d+x|_x\d+)/, '_100x100').split('?')[0];
                  }
                }

                var priceText = '';
                if (priceEl) {
                  priceText = priceEl.textContent.trim().replace(/\s+/g, ' ');
                }

                var item = document.createElement('a');
                item.className = 'inline-search-item';
                item.href = href;
                item.setAttribute('role', 'option');
                item.id = 'InlineSearchResult' + index;

                var imgHTML = imgSrc
                  ? '<img class="inline-search-item__image" src="' + imgSrc + '" alt="" loading="lazy" />'
                  : '<div class="inline-search-item__image"></div>';

                item.innerHTML =
                  imgHTML +
                  '<div class="inline-search-item__info">' +
                    '<span class="inline-search-item__title">' + title + '</span>' +
                    (priceText ? '<span class="inline-search-item__price">' + priceText + '</span>' : '') +
                  '</div>';

                productsDiv.appendChild(item);
              });

              resultsBox.appendChild(productsDiv);
            }

            // Build page results
            if (hasPages) {
              var pagesDiv = document.createElement('div');
              pagesDiv.className = 'inline-search-pages';

              var heading = document.createElement('div');
              heading.className = 'inline-search-pages__heading';
              heading.textContent = theme.strings.generalSearchPages || 'Pages';
              pagesDiv.appendChild(heading);

              pageBlocks.forEach(function (block) {
                var a = block.querySelector('a');
                if (!a) return;
                var pageItem = document.createElement('a');
                pageItem.className = 'inline-search-page-item';
                pageItem.href = a.getAttribute('href');
                pageItem.textContent = a.textContent.trim();
                pagesDiv.appendChild(pageItem);
              });

              resultsBox.appendChild(pagesDiv);
            }

            // View all link
            var viewAll = document.createElement('a');
            viewAll.className = 'inline-search-view-all';
            viewAll.href = buildResultURL(valueToSearch);
            viewAll.textContent = theme.strings.generalSearchViewAll || 'View all results';
            resultsBox.appendChild(viewAll);

            searchContainer.classList.add('inline-header-search--has-results');
            searchInput.setAttribute('aria-expanded', 'true');

            // Update status
            var status = document.getElementById('InlineSearchResultsStatus');
            if (status && resultsMessage) {
              status.innerHTML = resultsMessage.innerHTML;
            }

            activeResultIndex = -1;
          })
          .catch(function (error) {
            if (error.name !== 'AbortError') {
              console.warn('Inline search error:', error);
            }
          });
      }, searchTimeoutThrottle);
    } else if (valueToSearch.length === 0) {
      oldSearchValue = '';
      if (searchAbortController !== null) {
        searchAbortController.abort();
        searchAbortController = null;
      }
      clearTimeout(searchTimeoutID);
      closeResults();
    }
  }

  // Keyboard navigation
  function handleKeyDown(evt) {
    var options = resultsBox.querySelectorAll('.inline-search-item, .inline-search-page-item');
    if (options.length === 0) return;

    if (evt.key === 'ArrowDown') {
      evt.preventDefault();
      activeResultIndex = Math.min(activeResultIndex + 1, options.length - 1);
      updateActive(options);
    } else if (evt.key === 'ArrowUp') {
      evt.preventDefault();
      activeResultIndex = Math.max(activeResultIndex - 1, 0);
      updateActive(options);
    } else if (evt.key === 'Enter' && activeResultIndex >= 0) {
      evt.preventDefault();
      options[activeResultIndex].click();
    } else if (evt.key === 'Escape') {
      closeResults();
      searchInput.blur();
    }
  }

  function updateActive(options) {
    options.forEach(function (opt) { opt.classList.remove('search-result-active'); });
    if (activeResultIndex >= 0 && activeResultIndex < options.length) {
      var active = options[activeResultIndex];
      active.classList.add('search-result-active');
      searchInput.setAttribute('aria-activedescendant', active.id || '');
      // Scroll into view if needed
      active.scrollIntoView({ block: 'nearest' });
    }
  }

  // Bind events
  searchInput.addEventListener('keyup', handleInputChange);
  searchInput.addEventListener('change', handleInputChange);
  searchInput.addEventListener('keydown', handleKeyDown);

  // Re-open results on focus if we have a value
  searchInput.addEventListener('focus', function () {
    if (searchInput.value.trim().length > 0 && resultsBox.children.length > 0) {
      searchContainer.classList.add('inline-header-search--has-results');
    }
  });
})();
